/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import AIObjectPanel from "../../hubspot/new-flow/steps/AIObjectPanel";

interface GmailNewFlowProps {
  isConnected?: boolean;
  integrationId?: string;
}

const GmailNewFlow = ({ isConnected, integrationId }: GmailNewFlowProps) => (
  isConnected ? (
    <AIObjectPanel
      slug="emails"
      providerKey="gmail"
      providerLabel="Gmail"
      isConnected={isConnected}
      integrationId={integrationId}
      layout="inline"
      onToggleSelected={() => {
        // For Gmail, we only support conversation_messages
        // Toggle logic is handled by the AIObjectPanel component
      }}
    />
  ) : (
    null
  )
);

export default GmailNewFlow;
